// const API_URL =
//     document.domain === 'localhost'
//     ? "http://localhost:4500"
//     : "production";
const API_URL = 'https://5murdakpl0.execute-api.ap-south-1.amazonaws.com/prod'
const Apis = {

  //User api
  GetUserLogin: `${API_URL}/user/login`,
  GetUserRegsiter: `${API_URL}/user/register`,
  GetUserVerify: `${API_URL}/user/verify`,
  GetUserResendOtp: `${API_URL}/user/resendOtp`,
  GetUserForgetPass: `${API_URL}/user/forget-password`,
  GetUserResetPass: `${API_URL}/user/reset-password`,
  GetDeleteUserList: `${API_URL}/user`,


  // panel API Path
  GetSubmitArticle: `${API_URL}/mail/submit`,
  GetAllUserArticle: `${API_URL}/article/getbyid`,

  // public Articl API
  GetAllSearchArticle: `${API_URL}/articles/search`,
  GetAllMostDownloadArticle: `${API_URL}/articles/mostDownloaded`,
  GetAllMostViewArticle: `${API_URL}/articles/mostView`,
// https://5murdakpl0.execute-api.ap-south-1.amazonaws.com/prod/mail/submit
  // fileview URL
  GetFileViewPath: `${API_URL}/file-view`,
};
export { API_URL, Apis };
